import { createSyncAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';

export default function generalInitializerTransactionAction() {
	const action = createSyncAction(ActionTypes.GENERAL_INITIALIZER_TRANSACTION_ACTION, null);
	return action;
}
